import { BriefingModel } from "../../models/briefing"
import {
    STUDIO_BRIEFING_EMAIL_CANCEL,
    STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE,
    STUDIO_BRIEFING_EMAIL_MODEL_UPDATE,
    STUDIO_BRIEFING_EMAIL_REQUEST,
    STUDIO_BRIEFING_EMAIL_RESPONSE,
    STUDIO_BRIEFING_ERROR_RESPONSE,
    STUDIO_BRIEFING_REQUEST,
    STUDIO_BRIEFING_RESPONSE,
    STUDIO_TOGGLE_BRIEFING_EMAIL_MODAL,
    UNAUTHENTICATED
} from "../../actions/action-types"

import { briefingIntroductionMessageLimit } from "../../config/application-definitions"

const defaultState = {
    isFetchingBriefing: false,
    isSendingBriefingEmail: false,
    isModalOpen: false,
    model: new BriefingModel(),
    canSend: false,
    introductionLengthError: false
}

export default (state = defaultState, action) => {
    const { type, name, value } = action
    switch (type) {
        case STUDIO_BRIEFING_REQUEST:
            return {
                ...state,
                isFetchingBriefing: true
            }
        case STUDIO_BRIEFING_RESPONSE:
        case STUDIO_BRIEFING_ERROR_RESPONSE:
            return {
                ...state,
                isFetchingBriefing: false
            }
        case STUDIO_BRIEFING_EMAIL_REQUEST:
            return {
                ...state,
                isSendingBriefingEmail: true
            }
        case STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE:
            return {
                ...state,
                isSendingBriefingEmail: false
            }
        case STUDIO_TOGGLE_BRIEFING_EMAIL_MODAL:
            return {
                ...state,
                isModalOpen: !state.isModalOpen
            }
        case STUDIO_BRIEFING_EMAIL_MODEL_UPDATE:
            const model = state.model.set(name, value)
            const introductionLengthError =
                model.introduction.length > briefingIntroductionMessageLimit
            return {
                ...state,
                model,
                canSend:
                    model.recipients.length > 0 && !introductionLengthError,
                introductionLengthError
            }
        case STUDIO_BRIEFING_EMAIL_CANCEL:
            return {
                ...state,
                model: new BriefingModel(),
                canSend: false,
                isModalOpen: false,
                introductionLengthError: false
            }
        case STUDIO_BRIEFING_EMAIL_RESPONSE:
        case UNAUTHENTICATED:
            return defaultState
        default:
            return state
    }
}
